export const SERVICES_LIST_ACTION = "SERVICES_LIST_ACTION"
export const ADD_SERVICES_ACTION = "ADD_SERVICES_ACTION";
export const UPDATE_SERVICES_ACTION = 'UPDATE_SERVICES_ACTION';


export const servicesList=(servicesList)=>({
    type: SERVICES_LIST_ACTION ,
    payload: servicesList

})

export const addServices = (service) => ({
    type: ADD_SERVICES_ACTION,
    payload: service,
});

export const updateServices = (service) => ({
    type: UPDATE_SERVICES_ACTION,
    payload: service,
  });
